import styled from 'styled-components';

export const ContactContainer = styled.div`
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 30px;
    min-height: calc(100vh - 80px);
    position: relative;
    z-index: 1;
`;

export const ContactWrapper = styled.div`
    z-index: 1;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ContactH1 = styled.h1`
    font-size: 2.5rem;
    color: #010606;
    margin-bottom: 16px;
    text-align: center;
    font-weight: 600;

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }
`;

export const ContactP = styled.p`
    font-size: 1.1rem;
    color: #333;
    margin-bottom: 32px;
    text-align: center;
    max-width: 800px;
    line-height: 1.5;
`;

export const FormWrapper = styled.div`
    width: 100%;
    max-width: 800px;
    height: 70vh;
    min-height: 500px;
    background: #f7f7f7;
    border-radius: 10px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
    overflow: hidden;
`;

export const Iframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: 0;
`;
